import { render } from "./FieldListItem.vue?vue&type=template&id=2d5e0b60"
import script from "./FieldListItem.vue?vue&type=script&lang=js"
export * from "./FieldListItem.vue?vue&type=script&lang=js"

import "./FieldListItem.vue?vue&type=style&index=0&id=2d5e0b60&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__